/*Live sockets data functions*/
export function updatePrices(origData, quotesItem, percentage) {
  let data = {...origData}
  if (quotesItem != undefined) {
    if (quotesItem.a > data.a) {
      data.ca = "red_color";
    } else if (quotesItem.a < data.a) {
      data.ca = "green_color";
    } else {
      data.ca = "grey_color";
    }

    if (quotesItem.b < data.b) {
      data.cb = "green_color";
    } else if (quotesItem.b > data.b) {
      data.cb = "red_color";
    } else {
      data.cb = "grey_color";
    }
  }

  if (quotesItem.d != undefined) {
    data.d = quotesItem.d;
  } else {
    data.d = 2;
  }

  if (percentage != undefined) {
    var per = percentage;
    data.percentColor = "";

    if (parseFloat(per) < parseFloat(data.b)) {
      data.percentColor = "green_color";
    } else if (parseFloat(per) > parseFloat(data.b)) {
      data.percentColor = "red_color";
    } else {
      data.percentColor = "grey_color";
    }

    let change = (100 * (Number(data.b) / Number(per)) - 100).toFixed(2);
    data.percentValue = change + "%";
  }
  return data;
}

export function processInitialSocketData(data, symbolsData) {
  //todo: consider forwarding most of the logic here, into the view component
  //calculate daily statistics
  if (data.low > data.bid) {
    data.low = data.bid;
  }
  if (data.bid > data.high) {
    data.high = data.bid;
  }
  data.output = ((data.bid - data.low) * 100) / (data.high - data.low);

  const attrName = [
    "periodD1",
    "periodD7",
    "periodD30",
    "periodMN6",
    "periodMN12"
  ];
  let periods = []; //written "badly" in order to synchronize to previously written code used at the website's logic.
  let toSplice = []; //written "badly" in order to synchronize to previously written code used at the website's logic.
  data.calcData = {};
  if(!symbolsData) {
    return ;
  }
  attrName.forEach(attr => {
    let periodObj = {};
    if (!symbolsData[attr]) {
      symbolsData[attr] = `${data.bid}`;
      console.warn('!! No', attr, 'for', data, '::', symbolsData);
    }
    periodObj.num = (
      100 * (Number(data.bid) / Number(symbolsData[attr])) -
      100
    ).toFixed(2);
    data.calcData[attr] = periodObj;
    periods.push(parseFloat(periodObj.num)); //written "badly" in order to synchronize to previously written code used at the website's logic.
    toSplice.push(parseFloat(Math.abs(periodObj.num))); //written "badly" in order to synchronize to previously written code used at the website's logic.
  });

  // //calculate period 1d
  data.d1_num = (
    100 * (Number(data.bid) / Number(symbolsData.periodD1)) -
    100
  ).toFixed(2);
  data.d1_num = data.d1_num === "Infinity" ? 0 : data.d1_num;
  data.d1_num_main = (Number(data.bid) - Number(symbolsData.periodD1)).toFixed(
    symbolsData.digits
  );
  //
  // /*if positive add plus sign*/
  if (data.d1_num > 0) data.d1_num = "+" + data.d1_num;
  //
  //  graph
  var max = Math.max.apply(null, toSplice);
  var min = Math.min.apply(null, toSplice);
  toSplice.splice(toSplice.indexOf(max), 1);
  toSplice.splice(toSplice.indexOf(min), 1);
  var secondMax = Math.max.apply(null, toSplice);
  var secondMin = Math.min.apply(null, toSplice);
  toSplice.splice(toSplice.indexOf(secondMax), 1);
  toSplice.splice(toSplice.indexOf(secondMin), 1);

  if (max < 0) {
    var temp = max;
    max = min;
    min = temp;
    temp = secondMax;
    secondMax = secondMin;
    secondMin = temp;
  }

  for (let value of Object.values(data.calcData)) {
    let graphWidth = parseFloat((Math.abs(value.num) / Math.abs(max)) * 100);
    graphWidth = parseFloat(graphWidth / 2);
    if (value.num > 0) value.graphWidth = graphWidth;
    else value.graphWidth = -graphWidth;
    value.graphWidth = Math.abs(value.graphWidth);
  }
  return data;
}

export function visualPrice(priceObj, priceKey, digitFixKey) {
  if (priceObj !== undefined) {
    let price = priceObj[priceKey];
    if (digitFixKey) {
      price = parseFloat(price).toFixed(priceObj[digitFixKey]);
    }
    return price;
  }
  return "";
}
